import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
    selector: '[validLimitRange]'
})
export class LimitRangeDirective implements OnInit {

    @Input('validLimitRange') controlLimit: { minimo_permitido: number, maximo_permitido: number };

    private isValidating = false;

    constructor(private el: ElementRef) { }

    ngOnInit() {
        this.el.nativeElement.addEventListener('input', this.validateInput.bind(this));
    }

    private validateInput(event: InputEvent) {
        if (this.isValidating) return;
        this.isValidating = true;

        const input = event.target as HTMLInputElement;
        let value = input.value || '';

        // Solo números
        value = value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');

        // Limite de longitud
        if (value.length > 5) {
            value = value.slice(0, 5);
        }

        // Validar rango
        const num = Number(value);
        if (!isNaN(num)) {
            const minimo = this.controlLimit?.minimo_permitido;
            const maximo = this.controlLimit?.maximo_permitido;
            if (minimo !== undefined && minimo !== null && num < minimo) {
                value = String(0);
            }
            if (maximo !== undefined && maximo !== null && num > maximo) {
                value = String(maximo);
            }
        }

        input.value = value;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        this.isValidating = false;
    }
}
